import {PlayerCopy} from "../../pages";
import PlayerTransferAccount from "./PlayerTransferAccount";
import DefaultMainPage from "../../pages/DefaultMainPage";
import CustomBoardViewer from "./CustomBoardViewer";
import GroupBan from "./GroupBan";
import RestorePass from "./RestorePass";

const playerCopyMenuItems = [
    {path: '/playerCopy', component: <PlayerCopy/>, label: '유저 정보 복사'},
    {path: '/playerCopy/transfer', component: <PlayerTransferAccount/>, label: '유저 계정 이전'},
    {path: '/playerCopy/boardViewer', component: <CustomBoardViewer/>, label: '이벤트 보드 뷰어'},
    {path: '/playerCopy/groupBan', component: <GroupBan/>, label: '그룹 밴 관리'},
    {path: '/playerCopy/passRestore', component: <RestorePass/>, label: '패스 복구'},
]

export const playerCopyRoutes = {
    path: '/playerCopy',
    component: <DefaultMainPage buttons={playerCopyMenuItems}/>,
    children: playerCopyMenuItems
}